<template>
	<div data-slide="slide" class="slide" :class="{ready: ready === true}" :data-loadedEls="loadedElements">
        <div class="slide-items" ref="slideItems">
            <slot name="content"></slot>
        </div>
        <nav class="slide-nav">
            <div class="nav-ui">
                <slot name="nav-ui"></slot>
            </div>
            <div class="slide-thumb" :style="'--slideDuration:'+slideDuration+'; --slideLength:'+slides.length+';'">
                <span :key="index+'-thumb'" v-for="(item, index) in slides" :class="{active: index === active, filled: index < active}"></span>
            </div>
            <button @click.prevent="prev($event)" class="slide-prev">Prev</button>
            <button @click.prevent="next($event)" class="slide-next">Next</button>
        </nav>
        <div class="loader">
            <slot name="loader"></slot>
        </div>
    </div>
</template>
<script type="text/javascript">
	// import helper from './../helpers';

	export default {
		name: 'Story',
		props: ['duration', 'loadedElements'],
		data() {
			return {
				timer: 5000,
                // ready: false,
                active: -1,
                timeout: function(){return},
                slides: 0,
                isComplete: false,
                slideElements: false
			}
		},
        computed: {
            slideDuration() {
              // calc css animation value (ie. 5s)
              return Math.floor(this.timer/1000)+'s';
            },
            ready(){
                // console.log('isready',this.loadedElements,this.slides.length);
                return (this.loadedElements >= this.slides.length);
            }
        },
		methods: {
            next(event) {
              this.isComplete = (event)?false:this.complete;
              if (this.active < (this.slides.length - 1)) {
                this.active = this.active+1;
              } else {
                // below lets you cycle through again
                // this.active = 0;
                //below ends on the last slide and ends auto nav
                this.active = this.slides.length-1;
                this.isComplete = true;
              }
              this.autoSlide();
            },
            prev(event) {
              this.isComplete = (event)?false:this.complete;
              if (this.active > 0) {
                this.active = this.active -1;
              } else {
                // below code lets you go to the last slide
                // this.active = (this.slides.length - 1);
                //below code keeps you on the first, but restarts the animation (more inline with insta ux)
                this.active = -1;
                setTimeout(this.next,1);
              }
              this.autoSlide();
            },
            autoSlide() {
              clearTimeout(this.timeout);
              if(this.isComplete !== true){
                this.timeout = setTimeout(this.next, this.timer);
              }
            }
		},
        watch: {
            active(v){
                // console.log('change',v,this.$refs.slideItems.children);
                let activeElement = this.$refs.slideItems.children[v];
                if(activeElement){
                   [...this.$refs.slideItems.children].forEach(element => element.classList.remove('active'));
                    activeElement.classList.add('active');
                }
            },
            ready(newValue){
                // console.log('ready watcher',newValue);
                if(newValue === true){
                    setTimeout(this.active = 0,100);
                    this.autoSlide();
                }
            }
        },
        mounted() {
            // console.log('refz',this.$refs);
            this.slideElements = [...this.$refs.slideItems.children];
            console.log('elements',this.slideElements);
            // window.setTimeout(this.ready = true,10000);
            this.slides = new Array(this.$refs.slideItems.children.length);
		}
	}
</script>
<style>
	.slide {
        --navProgressHeight: 3px;
        --navProgressPadding: 6px;
    }

    .slide {
        width: 100%;
        max-width: 450px;
        min-height: 300px;
        margin: 0 auto;
        display: grid;
        position: relative;    
    }

    .slide:not(.ready) {
        padding: 100% 0 0 0;
    }

    .slide:not(.ready) .loader {
        width:64px;
        height:64px;
        position: absolute;
        top: calc(50% - 32px);
        left: calc(50% - 32px);
        z-index: 3;
    }

    .slide:not(.ready) .slide-items, .slide:not(.ready) .slide-nav *:not(.nav-ui) {
        display: none;
    }

    .slide.ready .loader {
        width:0;
        height:0;
        opacity: 0;
    }

    .slide-items {
        position: relative;
        grid-area: 1/1;
        overflow: hidden;
    }

    .slide-items:empty:after {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        position: absolute;
        top: calc(150px - 32px);
        left: calc(50% - 32px);
        z-index: 2;
        content: '';
    }

    .slide-items img, .slide-items video {
        width: 100%;
        height: auto;
        display: block;
        overflow: hidden;
    }

    .slide-nav {
        width: 100%;
        height: 100%;
        grid-area: 1/1;
        z-index: 1;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto 1fr;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .nav-ui:empty {
        display: none;
    }

    .nav-ui:not(:empty) {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        position: absolute;
        top:calc(var(--navProgressHeight) + (var(--navProgressPadding)*2));
        right:var(--navProgressPadding);
        z-index: 11;;
    }

    .slide-nav button {
        -webkit-appearance: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        opacity: 0;
    }

    .slide-items > * {
        position: absolute;
        top: 0px;
        opacity: 0;
        pointer-events: none;
    }

    .slide-items > .active {
        position: relative;
        opacity: 1;
        pointer-events: initial;
    }

    .slide-thumb {
        --slideDuration: 5s;
        --slideLength: 0;
        width: 100%;
        padding: var(--navProgressPadding);
        background:linear-gradient(rgba(0,0,0,0.2),transparent);
        display: flex;
        grid-column: span 2;
    }

    .slide-thumb > span {
        flex: 1;
        display: block;
        height: var(--navProgressHeight);
        background: rgba(0, 0, 0, 0.4);
        margin: 0 1px;
        border-radius: 3px;
        overflow: hidden;
    }

    .slide-thumb > span.active::after, .slide-thumb > span.filled::after {
        content: '';
        display: block;
        height: inherit;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 3px;
    }

    .slide-thumb > span.active::after {
        transform: translateX(-100%);
        animation: thumb var(--slideDuration) forwards linear;
    }

    @keyframes thumb {
        to {
        transform: initial;
        }
    }
</style>